<!--台账设备树组件-->
<template>
	<div class="readDeviceTreeBody">
		<tree :checked="checkedShow" :imgMethod="imgMethod" :menuCheckedAble='true' :nowOpenFloorIds="nowOpenFloorIds" :dataList="dataList" :getNameMethod="getNameMethod" :getIdMethod="getIdMethod" :nowCheckId="nowCheckId" @checkItem="checkItem"></tree>
	</div>
</template>

<script>
	import tree from './tree.vue'
	import archivesStore from '../../../cache/archivesStore.js'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			tree
		},
		props: ["target","checked"],
		data() {
			return {
				nowCheckId: '',
				nowCheckItem: {},
				nowOpenFloorIds: []
			}
		},
		created() {},
		mounted() {
			//加载以后默认选中第一个设备
			var interval = setInterval(() => {
				if(isempty(this.dataList)) {
					return
				}
				this.checkFirst(this.dataList)
				clearInterval(interval)
			}, 500)
		},
		destroyed() {},
		computed: {
			checkedShow(){
				if(undefined == this.checked){
					return false
				}
				return this.checked
			},
			dataList() {
				var data  =  archivesStore.getters.getArchivesTree
				return isempty(data)?[]:[data]
			},
		},
		watch: {
			nowCheckItem(nv, ov) {
				this.$emit("checkItem", nv)
			}
		},
		methods: {
			checkFirst(dataList) {
					//递归打开层级直到找到选中的设备
					var obj = this.findDevice(dataList)
					if(undefined == obj){
						return 
					}
					this.nowOpenFloorIds = obj.floor
					this.nowCheckId = this.getIdMethod(obj.device)
					this.nowCheckItem = obj.device
			},
			imgMethod(item) {
				if(item.type == "group") {
					return resourcesStore.getters.getResourcesByName("tree/node_unit.png")
				} else if(item.entityName == 'AppEquipmentArchives') {
					return resourcesStore.getters.getResourcesByName("tree/node_dev.png")
				}
			},
			getIdMethod(item) {
				if(item.type == "group") {
					return item.id+'_'+item.type
				} else if(item.entityName == 'AppEquipmentArchives') {
					return item.id+'_'+item.type
				}
				return ''
			},
			getNameMethod(item) {
				if(item.type == "group") {
					return item.name
				}else if(item.entityName == 'AppEquipmentArchives') {
					return item.name
				}
				return item.propertyname
			},
			checkItem(item) {
				if(item.type == 'unit'){
					return
				}
				this.nowCheckId = this.getIdMethod(item)
				this.nowCheckItem = item
			},
			findDevice(dataList) {
				var list = []
				for(var i = 0, len = dataList.length; i < len; i++) {
					var item = dataList[i]
					if(item.entityName == 'AppEquipmentArchives' && item.id == this.target.targetId) {
						return {
							device: item,
							floor: [this.getIdMethod(item)]
						}
					}else if(!isempty(item.next)) {
						//找一下下级
						var obj = this.findDevice(item.next)
						if(obj != undefined) {
							//找到了,把自己的id也加进去
							obj.floor.push(this.getIdMethod(item))
							return obj
						}
					}
				}
			},
		}
	}
</script>

<style scoped>
	.readDeviceTreeBody {
		height: 100%;
		overflow: auto;
		/* background: white; */
	}
</style>